import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";

import iconLock from "../../../../images/icons/icon_lock_gray.svg";

import "./LimitedAccessComposer.style";

class LimitedAccessComposer extends PolymerElement {
  static get template() {
    return html`
      <style include="limited-access-composer-style"></style>

      <div class="limited-access-composer" role="region" aria-label="Akses terbatas">
        <div class="limited-access-composer__content">
          <div class="limited-access-composer__message-row">
            <img
              class="limited-access-composer__icon"
              src="[[iconLock]]"
              alt=""
              aria-hidden="true"
            />
            <template is="dom-if" if="[[chatCredit.insufficient_label]]">
              <p class="limited-access-composer__title">[[chatCredit.insufficient_label]]</p>
            </template>
          </div>

          <template is="dom-if" if="[[chatCredit.reset_label]]">
            <p class="limited-access-composer__reset">[[chatCredit.reset_label]]</p>
          </template>
        </div>

        <template is="dom-if" if="[[aiGeneralCopytext.cta_subscribe_label_web]]">
          <button
            type="button"
            class="limited-access-composer__cta"
            on-click="_onClickUnlimitedAccess"
          >
            [[aiGeneralCopytext.cta_subscribe_label_web]]
          </button>
        </template>
      </div>
    `;
  }

  static get properties() {
    return {
      chatCredit: { type: Object, value: null },
      aiGeneralCopytext: { type: Object, value: null },
      iconLock: { type: String, value: iconLock },
    };
  }

  // Tell the AI page to open the unlimited-access popup.
  _onClickUnlimitedAccess() {
    this.dispatchEvent(
      new CustomEvent("limited-access-cta-click", {
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define("limited-access-composer", LimitedAccessComposer);
